import { useState } from "react";
import { AlertTriangle } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useCloseOnScroll } from "@/hooks/useCloseOnScroll";

/**
 * Badge "Pilne" z popoverem wyjaśniającym 30-dniowy okres ważności.
 * Zamyka się przy scrollu (mobile UX).
 */
export const UrgentBadge = () => {
  const [open, setOpen] = useState(false);
  useCloseOnScroll(open, () => setOpen(false));

  // Hover only on devices with fine pointer (desktop) - na mobile pozostaje klik
  const hoverHandlers = {
    onMouseEnter: () => {
      if (window.matchMedia("(hover: hover) and (pointer: fine)").matches) setOpen(true);
    },
    onMouseLeave: () => {
      if (window.matchMedia("(hover: hover) and (pointer: fine)").matches) setOpen(false);
    },
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          onClick={(e) => e.stopPropagation()}
          {...hoverHandlers}
          aria-label="Co oznacza Pilne potrzeby?"
          className="inline-flex items-center gap-1 bg-urgent text-urgent-foreground text-[11px] sm:text-[10px] font-semibold px-2 sm:px-1.5 py-0.5 sm:py-0 leading-5 sm:leading-4 rounded-full cursor-pointer hover:opacity-90"
        >
          <AlertTriangle className="w-3 h-3 sm:w-2.5 sm:h-2.5" />
          Pilne
        </button>
      </PopoverTrigger>
      <PopoverContent
        side="top"
        align="start"
        sideOffset={8}
        collisionPadding={16}
        sticky="always"
        avoidCollisions
        className="w-[240px] text-xs leading-relaxed p-3 z-[2200]"
        onClick={(e) => e.stopPropagation()}
        onMouseEnter={hoverHandlers.onMouseEnter}
        onMouseLeave={hoverHandlers.onMouseLeave}
      >
        <p className="font-semibold text-foreground mb-1">Pilne potrzeby</p>
        <p className="text-muted-foreground">
          Oznaczenie aktywne tylko przez 30 dni od zgłoszenia - więc te potrzeby są naprawdę aktualne i pilne.
        </p>
      </PopoverContent>
    </Popover>
  );
};
